import { useRefundEligibility } from 'hooks/refund-eligibility';
import { useFlag } from 'utils/launchdarkly';
import { routes } from 'utils/routing';
import { useSupportLink } from 'utils/support/use-support-link';

export const useHelpLinkUrlGenerator = (rbiOrderId: string) => {
  const enablePypestream = useFlag('enable-pypestream');
  const supportLink = useSupportLink();

  const enableGuestAndMultiStepSupportForm = useFlag(
    'enable-guest-and-multi-step-support-page'
  );

  const { isOrderEligibleForRefund } = useRefundEligibility({ orderId: rbiOrderId });

  //  CIR or the generic support form
  const supportV1Link = isOrderEligibleForRefund
    ? `${routes.reportOrderIssue}/${rbiOrderId}`
    : supportLink;

  const needHelpLinkUrl = enableGuestAndMultiStepSupportForm ? supportLink : supportV1Link;

  const pypestreamUrl = rbiOrderId ? `${routes.support}?orderId=${rbiOrderId}` : supportLink;

  return enablePypestream ? pypestreamUrl : needHelpLinkUrl;
};
